import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { FirmwareInstructionsBaseComponent } from "@mypxplat/xplat/features";
import { StorageService, UserService, ProductService } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppService } from "@mypxplat/xplat/web/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-firmware-instructions",
  templateUrl: "firmware-instructions.component.html",
  standalone: false,
})
export class FirmwareInstructionsComponent extends FirmwareInstructionsBaseComponent implements OnInit {
  @Input() optionCard: any;
  @Input() productDetails: any;
  @Input() dealer: boolean;
  /** Optional preloaded HTML from the hasInstructions check — skips a second fetch. */
  @Input() content: any;
  public type: string;
  public markingUpdated: boolean = false;
  public loadingContent: boolean = true;

  public ecoSystemProducts: Array<any>;

  private _firmware: any;
  private _instructionsStarted = false;

  @Input()
  set firmware(value: any) {
    this._firmware = value;
    if (value) this.startFirmwareInstructions();
  }
  get firmware() {
    return this._firmware;
  }

  constructor(
    storageService: StorageService,
    userService: UserService,
    public activeModal: NgbActiveModal,
    private _productService: ProductService,
    public appService: AppService
  ) {
    super(userService);
  }

  ngOnInit() {
    if (this.firmware) {
      this.startFirmwareInstructions();
    } else if (this.optionCard) {
      this._productService.getOptionCardInstallationInstructions(this.optionCard.parentLicenseId, this.optionCard.id).subscribe((result: any) => {
        this.loadingContent = false;
        this.content = result.content;
        if (result.title == "Firmware Recovery Instructions") {
          this.type = "recovery";
        } else {
          this.type = "update";
        }
      });
    }
  }

  private startFirmwareInstructions() {
    if (!this.firmware || this._instructionsStarted) return;
    this._instructionsStarted = true;
    this.type = "update";

    if (this.productDetails && this._productService.ecosystemProducts[this.productDetails.stringId]) {
      this.ecoSystemProducts = [];
      for (var i in this._productService.ecosystemProducts) {
        if (this._productService.productsByStringIDs[i] && i != this.productDetails.stringId) this.ecoSystemProducts.push(this._productService.productsByStringIDs[i]);
      }
    }

    // Caller may have already fetched instructions (hasInstructions check) — skip a second request.
    if (this.content) {
      this.loadingContent = false;
      return;
    }
    this.loadInstructions(this.firmware);
  }

  loadNewInstructions(prod) {
    this.loadingContent = true;
    this._productService.getProductSnapshot(prod.id).subscribe((result) => {
      this._instructionsStarted = false;
      this.content = undefined;
      this.firmware = {
        product_id: result.product.id,
        version: result.firmware[0].version,
        dealer: true,
      };
      this.updateEcosystemNotice(result);
    });
  }

  updateEcosystemNotice(displayedProduct) {
    this.ecoSystemProducts = [];
    for (var i in this._productService.ecosystemProducts) {
      if (this._productService.productsByStringIDs[i] && i != displayedProduct.stringId) this.ecoSystemProducts.push(this._productService.productsByStringIDs[i]);
    }
  }

  // `loadingContent` gates the spinner, so it has to be cleared on the error path too —
  // subscribing with only a next handler meant any non-2xx (e.g. the 422 a missing license id
  // produced) left the modal spinning with no way out. Surface the error and close, matching
  // haveUpdated() below.
  loadInstructions(firmware) {
    this._productService.getFirmwareInstructions(firmware.product_id, firmware.version, firmware.dealer).subscribe({
      next: (result: any) => {
        this.loadingContent = false;
        this.content = result.content;
      },
      error: (error) => {
        this.loadingContent = false;
        this.appService.alertError(error);
        this.activeModal.close();
      },
    });
  }

  haveUpdated() {
    this.markingUpdated = true;
    let prod_id, version;
    if (this.firmware) {
      prod_id = this.firmware.product_id;
      version = this.firmware.version;
    } else if (this.optionCard) {
      prod_id = this.optionCard.product_id;
      version = this.optionCard.firmware.version;
    }
    this._productService.updateFirmware(prod_id, version).subscribe(
      (result: any) => {
        this._productService.getProducts(true).subscribe();
        this.markingUpdated = false;
        alert("Thanks for updating your firmware!");
        this.activeModal.close();
      },
      (error) => {
        this.markingUpdated = false;
        this.appService.alertError(error);
        this.activeModal.close();
      }
    );
  }
}
